module.exports = __webpack_public_path__ + "static/allins-logo-d6c671c4d8bba4ffe0f08c2df00d5a99.png";